module.exports = __webpack_public_path__ + "img/logo_foxgaming.247a9673.png";